import React from "react";

const PaginationHasMoreSelectors = () => {
	return <div className="pagination-has-more-selectors">...</div>;
};

export default PaginationHasMoreSelectors;
